<template>
  <div>
    <div class="flex justify-end mb-4">
      <button
        class="btn bg-green px-6 py-2 text-white mr-4"
        @click="addNewDashboard"
      >
        Add New Dashboard
      </button>
      <button
        class="btn bg-green px-6 py-2 text-white"
        @click="showAssignRoleModal"
      >
        Assign Dashboards
      </button>
    </div>
    <div>
      <Table :endpoint="endpoint" :tableConfig="tableConfig" />
    </div>
    <VModal
      name="add-dashboard-modal"
      :click-to-close="true"
      width="1200"
      height="90%"
    >
      <div class="p-8">
        <div class="form-wrapper edyst-form-group p-4">
          <h2 class="text-center">Add new report dashboard</h2>
          <form @submit="handleSubmit">
            <div class="flex flex-col mt-3 items-left justify-center">
              <label for="dashboard-name">Dashboard Name</label>
              <input
                id="dashboard-name"
                ref="dashboardName"
                v-model="dashboardName"
                class="p-3 border w-1/2"
                autofocus
                placeholder="Enter dashboard name"
                required
                type="text"
              />
            </div>
            <div class="flex flex-col mt-3 items-left justify-center">
              <label for="dashboard-base-url">Dashboard Base URL</label>
              <textarea
                id="dashboard-base-url"
                v-model="dashboardBaseUrl"
                class="p-3 border w-1/2"
                placeholder="Enter dashboard base URL"
                required
                type="text"
                style="height:5rem;margin-top:0"
              >
              </textarea>
            </div>
            <div>
              <h3 class="mt-6 mb-">URL Params:</h3>
            </div>
            <p v-if="params.length === 0" class="text-center mb-8">
              No param added yet!
            </p>
            <ReportDashboardParam
              v-for="(param, idx) in params"
              :key="'param' + idx"
              :param="param"
              :indexNo="idx"
              @UPDATE_PARAM_NAME="handleNameUpdate"
              @REMOVE_PARAM="removeParam"
            />
            <div class="flex items-center justify-end mt-4">
              <button
                class="add-param-btn"
                @click.prevent="addNewParam('text')"
              >
                &#43; Text Param
              </button>
              <button
                class="add-param-btn"
                @click.prevent="addNewParam('date')"
              >
                &#43; Range Param
              </button>
              <button
                class="add-param-btn"
                @click.prevent="addNewParam('email')"
              >
                &#43; Email Param
              </button>
              <button
                class="add-param-btn"
                @click.prevent="addNewParam('random')"
              >
                &#43; Random Param
              </button>
            </div>

            <div class="text-right">
              <button
                class="p-2 px-8 rounded-full bg-green text-white font-bold mt-4"
              >
                {{ editMode ? "Update" : "Add" }} Report Dashboard
              </button>
            </div>
          </form>
        </div>
      </div>
    </VModal>
    <VModal
      name="add-role-modal"
      :click-to-close="true"
      width="600"
      height="400"
    >
      <div class="p-8 w-full h-full">
        <form
          class="form-wrapper edyst-form-group"
          @submit.prevent="handleDashboardAssignmentSubmit"
        >
          <h2 class="text-center">Assign Dashboards to Role</h2>
          <label for="select-role">Select Role</label>
          <VueSelect
            id="select-role"
            class="w-full type-selector mb-4"
            label="name"
            :value="selectedRole"
            :options="allRoles"
            :reduce="d => `${d.name} : ${d.id}`"
            @input="option => (selectedRole = option.id)"
          />
          <label for="select-dashboard"
            >Select Dashboards
            <small class="text-red">* Multiple can be selected</small></label
          >
          <VueSelect
            class="w-full type-selector"
            label="name"
            :options="allDashboards"
            :reduce="d => d.name"
            :value="selectedDashboards"
            multiple
            @input="handleDashboardInput"
          />

          <div class="text-right">
            <button
              class="btn bg-green px-6 py-2 text-white mt-8"
              @click="assignDashboards"
            >
              Assign Role
            </button>
          </div>
        </form>
      </div>
    </VModal>
  </div>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"
import ReportDashboardParam from "@/components/ReportsDashboard/ReportDashboardParam"
import Table from "@/components/DataTable/Table"

export default {
  components: {
    ReportDashboardParam,
    VueSelect,
    Table,
  },
  data() {
    return {
      dashboardName: "",
      dashboardBaseUrl: "",
      dashboardId: "", // only for edit mode
      params: [],
      allDashboards: [],
      selectedRole: undefined,
      selectedDashboards: [],
      allRoles: [],
      editMode: false,
      endpoint: `${siteConfig.siteURL}admin/report_dashboards`,
      tableConfig: [
        {
          header: { textContent: "Name", sortingParam: "name" },
          path: "name",
          classList: "w-1/6",
        },
        {
          header: { textContent: "Id" },
          path: "id",
          classList: "w-1/6",
        },
        {
          header: { textContent: "Base URL" },
          path: "url",
          classList: "long-data-cell",
          formatter: url =>
            `<input value="${url}" class='base-url' style="margin:0" />`,
        },
        {
          header: { textContent: "Test URL" },
          path: "/",
          classList: "long-data-cell",
          formatter: ({ test_url }) =>
            `<input value='${test_url.url}' class='test-url' style="margin:0" />`,
        },
        {
          header: { textContent: "Test URL" },
          path: "params",
          classList: "long-data-cell",
          formatter: params => this.getFormattedParams(params),
        },
        {
          header: { textContent: "Edit" },
          path: "/",
          type: "button",
          classList: "rounded-sm m-0 edit-button",
          buttonText: `Edit`,
          onclick: dashboard => {
            this.editDashboard(dashboard)
          },
        },
      ],
    }
  },
  created() {
    this.fetchAllDashboards()
    this.fetchAllRoles()

    // test /admin/user/dashboards
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}admin/user/dashboards`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
    }).then(res => {
      console.log(res.data)
    })
  },
  methods: {
    getFormattedParams(params) {
      let textContent = ""
      params.forEach(item => {
        let str = ""
        Object.keys(item).forEach(key => {
          str += `<span class='param-name text-red'>${key}</span>: <span class='text-green-dark'>${item[key]}</span><br/>`
        })
        textContent += `<li class='mb-2'>${str}</li>`
      })
      return `<details style="width: fit-content;">
      <summary class='cursor-pointer py-1 pr-2' style="width: fit-content;">Params</summary>
      <ol class='pl-3 text-sm'>${textContent}</ol>
      </details>`
    },
    editDashboard(dashboard) {
      this.editMode = true
      this.dashboardName = dashboard.name
      this.dashboardBaseUrl = dashboard.url
      this.params = dashboard.params
      this.dashboardId = dashboard.id
      this.$modal.show("add-dashboard-modal")
    },
    assignDashboards() {
      const payload = {
        dashboards: this.selectedDashboards.map(d => d.id),
      }
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/roles/${this.selectedRole}/dashboards`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.$noty.success("Successfully assigned dashboards to the role")
          this.$modal.hide("add-role-modal")
          this.selectedRole = ""
          this.selectedDashboards = []
        })
        .catch(err => {
          this.$noty.error(
            "Couldn't assign dashboards to role, server responded with: ",
            err
          )
        })
    },
    handleDashboardInput(options) {
      this.selectedDashboards = options
    },
    showAssignRoleModal() {
      this.$modal.show("add-role-modal")
      setTimeout(() => {
        const nameInput = this.$el.querySelector("#select-role")
        if (nameInput) {
          nameInput.querySelector("input").focus()
        }
      }, 200)
    },
    addNewDashboard() {
      this.$modal.show("add-dashboard-modal")
      this.editMode = false
      this.dashboardName = ""
      this.dashboardBaseUrl = ""
      this.params = []
      this.dashboardId = ""
      setTimeout(() => {
        const nameInput = this.$el.querySelector("#dashboard-name")
        if (nameInput) {
          nameInput.focus()
        }
      }, 200)
    },
    fetchAllRoles() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/roles`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          this.allRoles = res.data.items
        })
        .catch(err => {
          this.$noty.error(
            `Couldn't not get all roles from server, server responded with: ${err}`
          )
        })
    },
    fetchAllDashboards() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/report_dashboards?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.allDashboards = res.data.items
      })
    },
    removeParam(indexNo) {
      this.params.splice(indexNo, 1)
    },
    handleNameUpdate(data) {
      const localCopy = JSON.parse(JSON.stringify(this.params))
      localCopy[data.idx][data.paramName] = data.value
      if (data.paramName === "type" && data.value === "date") {
        delete localCopy[data.idx].value
        localCopy[data.idx].range = -15
      }
      if (data.paramName === "type" && data.value === "text") {
        delete localCopy[data.idx].range
        localCopy[data.idx].value = "value"
      }
      this.params = localCopy
    },
    addNewParam(type) {
      const newParam = { name: "", type }
      if (type === "date") {
        newParam.range = -15
      } else if (type === "text") {
        newParam.value = "value"
      }
      this.params.push(newParam)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.addNewReportDashboard()
    },
    async addNewReportDashboard() {
      const payload = {
        name: this.dashboardName,
        url: this.dashboardBaseUrl,
        params: this.params,
      }
      if (this.editMode) {
        payload.dashboard_id = this.dashboardId
      }
      this.axios({
        method: this.editMode ? "put" : "post",
        url: `${siteConfig.siteURL}admin/report_dashboards${
          this.editMode ? `/${this.dashboardId}` : ""
        }`,
        data: payload,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(res => {
          if (res.data.status) {
            this.$noty.success(
              `Successfully ${
                this.editMode ? "updated" : "added"
              } new report dashboard.`
            )
            this.$modal.hide("add-dashboard-modal")
            this.params = []
            this.dashboardName = ""
            this.dashboardBaseUrl = ""
            this.fetchAllDashboards()
            this.editMode = false
          } else {
            this.$noty.error(
              `Couldn't add report dashboard, server responed with ${res.data}`
            )
          }
        })
        .catch(err =>
          this.$noty.error(`Something went wrong, server responed with ${err}`)
        )
    },
  },
}
</script>

<style scoped>
.form-wrapper {
  overflow: auto;
  width: 100%;
  height: 100%;
  margin: auto;
  line-height: 1.5;
}

.form-wrapper.edyst-form-group input {
  margin-top: 0;
}

.form-wrapper.edyst-form-group label {
  padding-bottom: 0;
  font-weight: bold;
}

.add-param-btn {
  display: block;
  margin-left: 0.4rem;
  padding: 0.15rem 0.5rem;
  border-radius: 3px;
  color: white;
  background: #6259c5;
  font-weight: normal;
  text-align: center;
}

.add-param-btn:focus,
.add-param-btn:active,
.add-param-btn:hover {
  filter: brightness(0.9);
}

.dashboard-table {
  table-layout: fixed;
}

tr td {
  overflow: hidden;
  height: 14px;
  white-space: nowrap;
}

tr:hover td {
  overflow: visible;
  height: auto;
  white-space: normal;
}
</style>

<style>
.long-data-cell .param-name {
  display: inline-block;
  width: 2.5rem;
}

.long-data-cell .base-url,
.long-data-cell .test-url {
  width: 100%;
  height: 1.5rem;
}
</style>
